import React from "react";

const Logo = ({ img }) => {
	return (
		<a href="/" className="logo">
			<img src={img} alt="" />
		</a>
	);
};

export default Logo;
